import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  number: '01',
  title: 'Memorizás, pero no conectás',
  description: 'Conocés las cartas, pero cuando aparecen juntas no sabés cómo construir una interpretación.',
  emphasis: false
}, {
  number: '02',
  title: 'Te quedás sin preguntas',
  description: 'La lectura avanza y no sabés qué preguntar para profundizar.',
  emphasis: false
}, {
  number: '03',
  title: 'Dudás frente a otra persona',
  description: 'Te preguntan qué significa una combinación y te cuesta responder con seguridad.',
  emphasis: false
}, {
  number: '04',
  title: 'Terminás improvisando',
  description: 'Cada lectura se siente diferente porque no tenés un método claro para seguir.',
  emphasis: false
}, {
  number: '05',
  title: '¿Y si te preguntan algo que no sabés interpretar?',
  description: 'Aparece una combinación inesperada y sentís que perdés el hilo de la lectura.',
  emphasis: true
}, {
  number: '06',
  title: '¿Y si terminás la lectura sin haber dado claridad?',
  description: 'Querías conectar las cartas y ofrecer una interpretación útil, pero te quedaste en significados aislados.',
  emphasis: true
}];
const titleReveal = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    amount: 0.15
  },
  transition: {
    duration: 0.55,
    ease: [0.22, 1, 0.36, 1] as const
  }
};
export function PainPoints() {
  return <section className="border-y border-[#eadfc9] bg-[#fffdf8] py-10 sm:py-12 lg:py-14" data-id="element-149" data-mp="1b3hol57xz4k8">
      <div className="mx-auto max-w-5xl px-4 sm:px-8" data-id="element-150" data-mp="1p30l10re4rgp">
        <div className="mx-auto max-w-3xl text-center" data-id="element-151" data-mp="1p3sea4ximd3t">
          <motion.p {...titleReveal} className="text-[10px] font-black uppercase tracking-[0.22em] text-[#b88631] sm:text-[11px]" data-id="element-152" data-mp="1k34p7osuk6c8">
            ¿Te pasa esto cuando leés las cartas?
          </motion.p>
          <motion.h2 {...titleReveal} transition={{
          ...titleReveal.transition,
          delay: 0.04
        }} className="mt-3 font-magical text-3xl font-bold leading-[0.96] tracking-tight text-purple-950 sm:text-4xl md:text-5xl" data-id="element-153" data-mp="2vhjdborfbt5c">
            <span className="block" data-id="element-154" data-mp="1y2wzitu6w3wg">Aprender Tarot es una cosa.</span>
            <span className="mt-1 block font-bold text-purple-800" data-id="element-155" data-mp="225bnfscpttul">Saber interpretarlo es otra.</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.45,
          delay: 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} className="mx-auto mt-4 max-w-xl text-sm font-medium leading-relaxed text-purple-950/70 sm:text-base" data-id="element-156" data-mp="273muxwfjfs9n">
            Conocer las cartas no siempre significa saber conectarlas en una lectura.
          </motion.p>
        </div>

        <div className="mx-auto mt-7 grid max-w-3xl grid-cols-2 gap-2.5 sm:mt-8 sm:gap-3" aria-label="Problemas habituales al interpretar Tarot" data-id="element-157" data-mp="qpmywwjtcmro">
          {painPoints.map((point, index) => <motion.article key={point.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.5,
          delay: index * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} className={`flex min-h-[158px] flex-col rounded-xl border bg-[#fffefa] p-3 text-left sm:min-h-[145px] sm:p-3.5 ${point.emphasis ? 'border-[#c99a9a]' : 'border-[#e6d3a8]'}`} data-id="element-158" data-mp="o572mumomd29" data-mpi={index}>
              <span className={`text-[10px] font-black tracking-[0.16em] ${point.emphasis ? 'text-[#8c3d3d]' : 'text-[#b88631]'}`} data-id="element-159" data-mp="fmhc53233pt">
                {point.number}
              </span>
              <h3 className="mt-2 text-[13px] font-bold leading-[1.15] text-purple-950 sm:text-sm" data-id="element-160" data-mp="3monexhnudsab">
                {point.title}
              </h3>
              <p className="mt-1.5 text-[11px] leading-snug text-purple-950/70 sm:text-xs" data-id="element-161" data-mp="3ioda48bsd7x1">
                {point.description}
              </p>
            </motion.article>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.15
      }} transition={{
        duration: 0.45,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1]
      }} className="mx-auto mt-7 max-w-2xl text-center font-magical text-2xl font-bold leading-tight text-purple-950 sm:mt-8 sm:text-3xl" data-id="element-162" data-mp="1hm5q47pvudvx">
          No necesitás memorizar otras 78 definiciones. Necesitás saber{' '}
          <strong className="font-bold text-purple-800" data-id="element-163" data-mp="12w7uj6pmilwp">qué hacer cuando las cartas están frente a vos.</strong>
        </motion.p>
      </div>
    </section>;
}